<template>
  <edit-module
    ref="editModule"
    :saving="saving"
    :disabled="!hasChanges"
    @submit="handleSave"
    @expand="toggleOpen"
  >
    <template #header>
      <scheduling-module-header
        :appointment="appointment"
      ></scheduling-module-header>
    </template>
    <template #body>
      <scheduling-module-form
        v-if="open"
        ref="form"
        :appointment="appointment"
        @changes-update="handleChanges"
      ></scheduling-module-form>
    </template>
  </edit-module>
</template>

<script>
import { mapActions } from "vuex";

import EditModule from "@/components/EditModule.vue";
import SchedulingModuleForm from "./SchedulingModuleForm.vue";
import SchedulingModuleHeader from "./SchedulingModuleHeader.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    EditModule,
    SchedulingModuleHeader,
    SchedulingModuleForm
  },
  props: {
    appointment: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      open: false,
      saving: false,
      hasChanges: false
    };
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  methods: {
    ...mapActions(["updateAppointment"]),
    handleSave() {
      this.v$.$validate().then((isValid) => {
        if (isValid) {
          const payload = this.$refs.form.getChanges();
          const link = this.appointment.links.update;
          if (link) {
            this.saving = true;
            this.updateAppointment({ link, data: payload })
              .then(() => {
                window.notify.success("Appointment updated successfully!");
                this.$refs.editModule?.handleClose();
              })
              .finally(() => (this.saving = false));
          } else {
            window.notify.error("Unable to edit this appointment.");
          }
        }
      });
    },
    toggleOpen() {
      this.open = !this.open;
    },
    handleChanges(changes) {
      // Fixes bug when rescheduling an appointment
      if (
        Object.prototype.hasOwnProperty.call(changes, "scheduled_time") &&
        !changes.scheduled_time
      ) {
        delete changes.scheduled_time;
      }
      this.hasChanges = Object.keys(changes).length > 0;
    }
  }
};
</script>

<style lang="scss" scoped></style>
